import React, { Component } from 'react';
import CadastroEndereco from './CadastroEndereco';
import CadastroLogin from './CadastroLogin';
import CadastroDocumentos from './CadastroDocumentos';
import CadastroTelefones from './CadastroTelefones';
import CadastroSistema from './CadastroSistema';

class FormularioCadastro extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagina: 0,
            aguarde: false,
            dadosLogin: {
                emailLogin: "",
                senha1: "",
                senha2: "",
                termos: false
            },
            dadosCadastro: {
                juridica: "true",
                docFazenda: "",
                nome: "",
                nomeFantasia: "",
                responsavel: ""
            },
            dadosTelefone: {
                telefone1: "",
                telefone2: ""
            },
            dadosEndereco: {
                logradouro: "",
                numero: "",
                complemento: "",
                bairro: "",
                cep: "",
                estado: "",
                cidade: "",
                codigoMunicipio: ""
            },
            dadosSistema: {
                nomeSistema: '',
                produto: 1
            }
        }
    }

    onChange(event) {
        var formulario = { ...this.state.formulario };
        if (event.target.type === "radio") {
            formulario[event.target.name] = (event.target.value == "true");
            console.log("radio " + event.target.name + " = " + event.target.value);
        } else {
            formulario[event.target.name] = event.target.value;

        }
        this.setState({ formulario: formulario }, () => {
            this.fireChanged();
        });
    }

    onChangeDocFazenda(state) {
        var formulario = { ...this.state.formulario };
        formulario.docFazenda = state.value;
        this.setState({ formulario: formulario }, () => {
            this.fireChanged();
        });
    }

    fireChanged() {
        if (this.props.onChange) {
            this.props.onChange(this.state);
        }
    }

    onChangeUpper(event) {
        var formulario = { ...this.state.formulario };
        formulario[event.target.name] = event.target.value.toUpperCase();
        this.setState({ formulario: formulario }, () => {
            this.fireChanged();
        });
    }


    render() {

        const pagina1 = <CadastroLogin onSubmit={(values) => {
            this.setState({
                dadosLogin: values,
                pagina: 1
            });
            window.scrollTo(0, 0);
        }} />

        const pagina2 = <CadastroDocumentos onSubmit={(values) => {
            this.setState({
                dadosCadastro: values,
                pagina: 2
            });

            fetch("cadastro/sugerenomesistema?nome="
                + encodeURIComponent(values.nome)
                + "&nomeFantasia="
                + encodeURIComponent(values.nomeFantasia)).then((response) => {
                    response.text().then((val) => {
                        var sugestao = val;
                        console.log("sugestao =  " + sugestao);
                        this.setState({ dadosSistema: { nomeSistema: sugestao } });

                    })
                });


            window.scrollTo(0, 0);
        }} />

        const pagina3 = <CadastroTelefones onSubmit={(values) => {
            this.setState({
                dadosTelefone: values,
                pagina: 3
            });
            window.scrollTo(0, 0);
        }} />

        const pagina4 = <CadastroEndereco onSubmit={(values) => {
            this.setState({
                dadosEndereco: values,
                pagina: 4
            })
            window.scrollTo(0, 0);
        }} />;

        const pagina5 = <CadastroSistema nomeSistema={this.state.dadosSistema.nomeSistema} onSubmit={(values) => {
            this.setState({ dadosSistema: { ...values, produto: 1 } }, () => {
                this.setState({ aguarde: true });
                fetch("cadastro/sistema", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ...this.state.dadosLogin,
                        ...this.state.dadosCadastro,
                        ...this.state.dadosTelefone,
                        ...this.state.dadosEndereco,
                        ...this.state.dadosSistema
                    })
                }).then(() => {
                    window.location.href = 'obrigado.html';
                }
                ).catch(() => {
                    alert("Ocorreu um erro ao realizar o cadastro. Tente novamente mais tarde.");
                    this.setState({ aguarde: false })
                })
            })

        }} />;

        const paginas = [pagina1, pagina2, pagina3, pagina4, pagina5];

        const aguarde = <div>Aguarde...</div>;

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-md-6 col-md-offset-3 text-center" >
                        <ul className={"nav nav-pills center-pills etapas " + (this.state.pagina < 1 ? "escondido" : "")} >
                            <li className={this.state.pagina == 0 ? "active" : ""}><a>1</a></li>
                            <li className={this.state.pagina == 1 ? "active" : ""}><a>2</a></li>
                            <li className={this.state.pagina == 2 ? "active" : ""}><a>3</a></li>
                            <li className={this.state.pagina == 3 ? "active" : ""}><a>4</a></li>
                            <li className={this.state.pagina == 4 ? "active" : ""}><a>5</a></li>
                        </ul>
                    </div>
                </div>
                {this.state.aguarde ? aguarde : paginas[this.state.pagina]}
                {/* 
                <hr />
                <pre>
                    {JSON.stringify(this.state, null, 2)}
                </pre>
                */ }
            </React.Fragment>
        );
    }
}

export default FormularioCadastro;